<div class="header">
  <h3 *ngIf="!selectedService" class="heading">{{ heading }}</h3>

  <h3 *ngIf="selectedService" class="service-header">
    <span
        [class.last-child-color]="selectedService.label === serviceBoxItems[serviceBoxItems.length-1].label">{{ selectedService.label }}</span>
<!--    <span *ngIf="selectedDistrict" class="service-title-district">in {{ selectedDistrict }}</span>-->
    <button class="close-service-button" (click)="onServiceClose()">zurück</button>
  </h3>
</div>

<div class="card-content actions" *ngIf="!selectedService">
  <ng-container *ngFor="let service of serviceBoxItems">
    <button class="action" (click)="onServiceLinkClick($event, service)">
      <ng-container *ngTemplateOutlet="serviceTitle;context:{$implicit:service}"></ng-container>
    </button>
  </ng-container>
</div>

<!--<form class="card-content service service-form" *ngIf="selectedService && !selectedDistrict">-->
<!--  <label>Stadtteil</label>-->
<!--  <mat-form-field appearance="outline" class="contact-partner-select-form">-->
<!--    <mat-label>Finden Sie den richtigen Ansprechpartner:</mat-label>-->
<!--    <mat-select disableOptionCentering (selectionChange)="onDistrictSelect($event.value)">-->
<!--      <mat-option value="option1" *ngFor="let district of districts" [value]="district">{{district}}</mat-option>-->
<!--    </mat-select>-->
<!--  </mat-form-field>-->
<!--</form>-->

<ng-container *ngIf="selectedService">
  <div class="card-content service service-contact" *ngIf="filteredContactPersons.length > 0; else noContactPersonFound">
    <div class="service-person-container" *ngFor="let filteredContactPerson of filteredContactPersons">
      <ed-clients-lazy-bb-picture
        class="service-contact-image cover"
        [blackbirdImage]="filteredContactPerson.image">
      </ed-clients-lazy-bb-picture>

      <div class="service-person-details">
        <div class="service-contact-info">
          <div class="service-contact-name">{{ filteredContactPerson.name }}</div>
          <div class="service-contact-position">{{ filteredContactPerson.jobTitle }}</div>
        </div>

        <div class="service-contact-contact">
          <a class="service-contact-link"
             [href]="filteredContactPerson.callNumText | germanTelOrFaxConverter"
             *ngIf="filteredContactPerson.callNumText"
          >{{ filteredContactPerson.callNumText }}</a>
          <a class="service-contact-link"
             [href]="'mailto:' + filteredContactPerson.email"
             *ngIf="filteredContactPerson.email"
          >Kontakt aufnehmen</a>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noContactPersonFound>
    <div class="card-content service service-contact">
      <div> kein Ansprechpartner gefunden</div>
    </div>
  </ng-template>
</ng-container>


<ng-template #serviceTitle let-service>
  <span class="service-title">
    <ed-clients-lazy-bb-picture
        class="service-title-icon contain"
        [blackbirdImage]="service.icon"></ed-clients-lazy-bb-picture>
      <span [innerHTML]="service.label"></span>
  </span>
</ng-template>
